/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceContentBlock } from './SurfaceContentBlock';
import {
    SurfaceContentBlockFromJSON,
    SurfaceContentBlockFromJSONTyped,
    SurfaceContentBlockToJSON,
    SurfaceContentBlockToJSONTyped,
} from './SurfaceContentBlock';

/**
 * 
 * @export
 * @interface SurfaceContainerConfig
 */
export interface SurfaceContainerConfig {
    /**
     * 
     * @type {Array<SurfaceContentBlock>}
     * @memberof SurfaceContainerConfig
     */
    children?: Array<SurfaceContentBlock>;
}

/**
 * Check if a given object implements the SurfaceContainerConfig interface.
 */
export function instanceOfSurfaceContainerConfig(value: object): value is SurfaceContainerConfig {
    return true;
}

export function SurfaceContainerConfigFromJSON(json: any): SurfaceContainerConfig {
    return SurfaceContainerConfigFromJSONTyped(json, false);
}

export function SurfaceContainerConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceContainerConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(SurfaceContentBlockFromJSON)),
    };
}

export function SurfaceContainerConfigToJSON(json: any): SurfaceContainerConfig {
    return SurfaceContainerConfigToJSONTyped(json, false);
}

export function SurfaceContainerConfigToJSONTyped(value?: SurfaceContainerConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(SurfaceContentBlockToJSON)),
    };
}

